import { useQuery } from "@apollo/client";
import type { Asset } from "@casey/db-types";
import { GET_ASSET_BY_ID } from "../gql";

export function useAsset(id: string) {
  const { data, loading, error, refetch } = useQuery<{
    asset: Asset;
  }>(GET_ASSET_BY_ID, {
    variables: { id },
    skip: !id,
    errorPolicy: "all",
  });

  return {
    asset: data?.asset || null,
    loading,
    error,
    refetch,
  };
}

export type { Asset };
